"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVirtualFloating = void 0;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _createVirtualElement = require("../createVirtualElement");
var _floatingUi = require("../libs/floating-ui");
var _index = require("../utils/index");
/**
 * `useFloating` with a controlled virtual element. Used to follow cursor
 * position.
 *
 * Default options:
 *
 * - `whileElementsMounted: autoUpdate`
 *
 * Additional options:
 *
 * - `getBoundingClientRect` to get the bounding client rect.
 * - `hidden` to hide the floating element
 *
 * Additional returns:
 *
 * - `style` to apply to the floating element
 * - `virtualElementRef`
 *
 * @see useFloating
 * @see https://floating-ui.com/docs/react-dom#virtual-element
 */
var useVirtualFloating = function useVirtualFloating(_ref) {
  var _ref$getBoundingClien = _ref.getBoundingClientRect,
    getBoundingClientRect = _ref$getBoundingClien === void 0 ? _index.getSelectionBoundingClientRect : _ref$getBoundingClien,
    floatingOptions = _objectWithoutProperties(_ref, ["getBoundingClientRect"]);
  var virtualElementRef = _react.default.useRef((0, _createVirtualElement.createVirtualElement)());
  var _react$default$useSta = _react.default.useState(true),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    visible = _react$default$useSta2[0],
    setVisible = _react$default$useSta2[1];
  var floatingResult = (0, _floatingUi.useFloating)(_objectSpread({
    // update on scroll and resize
    whileElementsMounted: _floatingUi.autoUpdate
  }, floatingOptions));
  var middlewareData = floatingResult.middlewareData,
    refs = floatingResult.refs,
    strategy = floatingResult.strategy,
    update = floatingResult.update,
    x = floatingResult.x,
    y = floatingResult.y;
  (0, _plateCommon.useIsomorphicLayoutEffect)(function () {
    virtualElementRef.current.getBoundingClientRect = getBoundingClientRect;
  }, [getBoundingClientRect, update]);
  (0, _plateCommon.useIsomorphicLayoutEffect)(function () {
    refs.setReference(virtualElementRef.current);
  }, [refs]);
  (0, _plateCommon.useIsomorphicLayoutEffect)(function () {
    if (!(middlewareData !== null && middlewareData !== void 0 && middlewareData.hide)) return;
    var referenceHidden = middlewareData.hide.referenceHidden;
    setVisible(!referenceHidden);
  }, [middlewareData.hide]);
  return _objectSpread({}, floatingResult, {
    style: {
      display: floatingOptions.open === false ? 'none' : undefined,
      left: x !== null && x !== void 0 ? x : 0,
      position: strategy,
      top: y !== null && y !== void 0 ? y : 0,
      visibility: visible ? undefined : 'hidden'
    },
    virtualElementRef: virtualElementRef
  });
};
exports.useVirtualFloating = useVirtualFloating;